import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  private readonly BASE_URL = environment.END_URL;

  getLocationList$: Observable<any> | undefined;
  getLocationAddress$: Observable<any> | undefined;

  constructor(private http: HttpClient) {}

  getAllLocations() {
    return this.http
      .get(`${this.BASE_URL}/api/location/all`)
      .pipe(shareReplay(1));
  }

  public getPublicAllLocation() {
    if (!this.getLocationList$) {
      this.getLocationList$ = this.getAllLocations();
    }
    return this.getLocationList$;
  }

  getLocation(ip: any) {
    return this.http.get(`https://ipapi.co/${ip}/json/`).pipe(shareReplay(1));
  }

  public getPublicLocation(ip: any) {
    if (!this.getLocationAddress$) {
      this.getLocationAddress$ = this.getLocation(ip);
    }
    return this.getLocationAddress$;
  }
}
